import React from 'react';
import { BsExclamationTriangle } from 'react-icons/bs';
import PageHeader from '../Components/PageHeader/PageHeader';
import wrong_route from '../Components/Images/wrong_route.png'

const WrongRoutePage = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      padding: '1.5rem',
    }}>
      <PageHeader title="Page not found" description="The page you requested does not exist or you do not have access." icon={BsExclamationTriangle} />
      <img
        src={wrong_route}
        alt="404 Not Found"
        style={{
          width: '300px',
          height: '300px',
          objectFit: 'contain',
          marginTop: '1.5rem',
        }}
      />
    </div>
  );
};

export default WrongRoutePage;
